export default {plugin:{ui_plugin_demo:{ui:{msg:'UI Plugin Demo'}}}};